<template>
  <div class="home" @click="closeAvailableFontsDropDown">
	<popup name="test" v-if="landscapeModal"  class="landscapeModal" @close="landscapeModal = false">
		
		<div slot="header">Brighton <i class="fa fa-times" aria-hidden="true" @click="landscapeModal=false"></i></div>
		<h3 slot="body">The Brighton's Love Lockets and more creator was designed to be used in lanscape mode.  Turn your device 90 degrees to use.
		<i class="fa fa-refresh" aria-hidden="true"></i></h3>
		<h3 slot="footer"><span @click="landscapeModal=false"><u></u></span></h3>
	</popup>
  	<div>
		  <!-- <div v-if="$route.params.storeType==1" v-html="header"></div> -->
		  <div v-if="$route.params.storeType==3"><brheader /></div>
		  <div v-if="$route.params.storeType==2"><bcheader /></div>
	    <!-- <div id="nav">
	      <ul class="breadcrumbs" v-if="$route.params.storeType==1">
	        <li><a href="https://www.brighton.com">Home</a></li>
	        <li><a href="https://app.brighton.com/lockets/create/1" @click="startOver()">Brighton Your Way Personalized Lockets and more</a></li>
	      </ul>
	    </div> -->
  	</div>
    <Step0 
		v-if="styleNumObj ==null" 
		v-on:selectStyleNum = "selectStyleNum"
		:reloadObj="reloadObj"
		:selectedStyleNum = "$route.params.selectedStyleNum"
	/>
	<div class="selectedStyle" v-if="styleNumObj!= null">
		<div class="leftSide">
			<span class="t1">{{styleNumObj.name}}</span>
			<span class="t2"><span v-if="styleNumObj.collection != ''">From the <a href=''>{{styleNumObj.collection}} collection</a></span></span>
			<span class="t3">{{styleNumObj.description}}</span>
		</div><div class="rightSide">
			<span class="t1">${{styleNumObj.price}}.00</span>
			<span class="t2">QUANTITY: <input type="text" v-model="orderQuantity"></span>
		</div>
		<div class="title">
			Photo Sizing
		</div>
	</div>
	<div class="main" v-if="styleNumObj!= null">
		<div class="left" :class="{step2: step == 2}" >
			<div class="preview leftSide">
				<!-- <img v-if="styleNumObj != null" :src="'https://app.brighton.com/lockets/img/'+styleNumObj.styleNum+'_01.jpg'" alt=""> -->
				<img v-if="styleNumObj != null" :src="'https://media.brighton.com/images/900x900/qi'+styleNumObj.styleNum.toLowerCase()+'_01.jpg'" alt="">
				
				<span class="title">PREVIEW</span>
			</div>
			<div class="preview rightSide" v-if="previewUserImgObj">

				<div class="leftCanvas userImage" v-if="styleNumObj.sides >= 4">
						<div class="userInputText" v-if="userData[3].userInputType == 2">
							<span :style="userData[3].selectedFont">{{userData[3].userInputText1}}</span>
							<span :style="userData[3].selectedFont">{{userData[3].userInputText2}}</span>
							<span :style="userData[3].selectedFont">{{userData[3].userInputText3}}</span>
						</div>
						<img :src="previewUserImgObj.url2"  alt="" class="" v-if="userData[3].userInputType == 2" />
						<div v-if="userData[3].userInputType != 2"><canvas id="leftSide3"></canvas></div>
				</div>
				<div style="display:none" v-if="userData[3].userInputType != 2"><canvas id="leftSideMask3"></canvas></div>

				<div class="leftCanvas userImage" v-if="styleNumObj.sides >= 3">
					<div class="userInputText" v-if="userData[2].userInputType == 2">
						<span :style="userData[2].selectedFont">{{userData[2].userInputText1}}</span>
						<span :style="userData[2].selectedFont">{{userData[2].userInputText2}}</span>
						<span :style="userData[2].selectedFont">{{userData[2].userInputText3}}</span>
					</div>
					<img :src="previewUserImgObj.url2"  alt="" class="" v-if="userData[2].userInputType == 2" />
					<div v-if="userData[2].userInputType != 2"><canvas id="leftSide2"></canvas></div>
				</div>
				<div style="display:none" v-if="userData[2].userInputType != 2"><canvas id="leftSideMask2"></canvas></div>




				<div class="leftCanvas userImage" v-if="styleNumObj.sides >= 2">
					<div class="userInputText" v-if="userData[1].userInputType == 2">
						<span :style="userData[1].selectedFont">{{userData[1].userInputText1}}</span>
						<span :style="userData[1].selectedFont">{{userData[1].userInputText2}}</span>
						<span :style="userData[1].selectedFont">{{userData[1].userInputText3}}</span>
					</div>
					<img :src="previewUserImgObj.url2"  alt="" class="" v-if="userData[1].userInputType == 2" />
					<div v-if="userData[1].userInputType != 2"><canvas id="leftSide"></canvas></div>
				</div>
				<div style="display:none" v-if="userData[1].userInputType != 2"><canvas id="leftSideMask"></canvas></div>
				
				<div class="rightCanvas userImage" :style="{width: styleNumObj.previewTextMaskWidth != 0 ? styleNumObj.previewTextMaskWidth + 'px' : '100px'}">
					<div class="userInputText" v-if="userData[0].userInputType == 2" :style="{top: styleNumObj.previewTextTop != 0 ? styleNumObj.previewTextTop + '%' : '28%'}">
						<span :style="userData[0].selectedFont">{{userData[0].userInputText1}}</span>
						<span :style="userData[0].selectedFont">{{userData[0].userInputText2}}</span>
						<span :style="userData[0].selectedFont">{{userData[0].userInputText3}}</span>
					</div>
					<img :src="previewUserImgObj.url1"  alt="" class="" v-if="userData[0].userInputType == 2"/>
					<div v-if="userData[0].userInputType != 2"><canvas id="rightSide"></canvas></div>
				</div>
				<div style="display:none" v-if="userData[0].userInputType != 2"><canvas id="rightSideMask"></canvas></div>


			</div>
		</div><div class="middle" :class="{step2: step == 2}">
			<div class="step1 step" :class="{active:currSideG==1}"><span>step <span class="num">1</span></span></div>
			<div class="step2 step" :class="{active:currSideG==0}"><span>step <span class="num">2</span></span></div>
		</div><div class="right" :style="rightPaneBackgrounColor" :class="{step2: step == 2}">
    		<Step1 
	    		ref="stepOne"
    			:currSideG = "currSideG"
    			v-on:startOver = "startOver" 
    			v-on:nextStep = "nextStep"
    			:styleNumObj="styleNumObj"
    			:userData="userData"
    			v-on:setUserData = "setUserDataFromStep1"
    			v-on:changeRightPaneColor = "changeRightPaneColor" 
    			v-show="step == 1" 
    			:winowClicked = "winowClicked"
    			v-on:setPreviewImageURL = "setPreviewImageURL"
	   			v-on:setPreviewUserImg = "setPreviewUserImg" 
    			/>
    		<Step2 
	   			:orderQuantity = "orderQuantity"
    			v-on:test = "test"
    			v-on:setUserData = "setUserDataFromStep2"
    			ref="stepTwo"
	    		:currSideG = "currSideG"
    			v-on:lastStep = "lastStep" 
    			v-on:startOver = "startOver" 
    			v-on:setPreviewUserImg = "setPreviewUserImg" 
    			:styleNumObj="styleNumObj" 
    			:userImages="userImages" 
    			:userInputTexts = "userInputTexts"
    			:userData = "userData"
    			:selectedUserInputType = "userInputType"
    			v-if="step == 2"
    			:storeType="parseInt($route.params.storeType)"
				:reloadObj="reloadObj"
				:theCanvasG="theCanvasG"
				:theCanvasPreview="theCanvasPreview"
				v-on:setPreviewUserImgs = "setPreviewUserImgs"
				:theCanvasPreviewRendered = "theCanvasPreviewRendered"
    			/>

		</div>
	</div>
	 <!-- <div v-if="$route.params.storeType==1"><bfooter/></div> -->
     <div v-if="$route.params.storeType==3"><brfooter/></div>
     <div v-if="$route.params.storeType==2"><bcfooter/></div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Step0 from '@/components/Step0.vue'
import Step1 from '@/components/Step1.vue'
import Step2 from '@/components/Step2.vue'
import brheader from '@/components/brheader.vue'
import brfooter from '@/components/brfooter.vue'
import bcheader from '@/components/bcheader.vue'
import bcfooter from '@/components/bcfooter.vue'
import bfooter from '@/components/bfooter.vue'
import bheader from '@/components/bheader.vue'
import popup from './popup'
import _ from 'underscore';
export default {
  	name: 'start',
	props: {
		// storeType: Number
		// selectedStyleNum: String
	},
  	data () {
  	return {
  		landscapeModal: true,
  		header:'',
  		footer:'',
			headerFooter: '',
  		counter: 0,
  		styleNumObj: null,
  		mask: null,
  		theCanvas: null,
  		step: 0,
  		previewStyleNumObj: null,
  		previewUserImgObj: null,
  		userImages: null,
  		userInputTexts: null,
  		userInputType: 1,
  		previewStyleNumCss: {},
  		reloadObj: null,
  		orderQuantity: 1,
  		winowClicked: 0,
  		currSideG: 0,
  		rightPaneBackgrounColor: {'background-color': '#f5f5f5'},
  		testValue: 0,
  		theCanvasG: null,
			theCanvasPreview: null,
			theCanvasPreviewRendered: 0,
  		userData: [
	        {
	          userImage: null,
	          userImageErr: null,
	          userInputType: 1,
	          userInputText1: '',
	          userInputText2: '',
	          userInputText3: '',
	          selectedFont: '',
	          isSaving: false
	        },
	         {
	          userImage: null,
	          userImageErr: null,
	          userInputType: 1,
	          userInputText1: '',
	          userInputText2: '',
	          userInputText3: '',
	          selectedFont: '',
	          isSaving: false
					},
					{
	          userImage: null,
	          userImageErr: null,
	          userInputType: 1,
	          userInputText1: '',
	          userInputText2: '',
	          userInputText3: '',
	          selectedFont: '',
	          isSaving: false
					},
					{
	          userImage: null,
	          userImageErr: null,
	          userInputType: 1,
	          userInputText1: '',
	          userInputText2: '',
	          userInputText3: '',
	          selectedFont: '',
	          isSaving: false
	        }
	      ],
	  	}
	},
	components: {
	Step1,
	Step0,
	Step2,
	brheader,
	brfooter,
	bcheader,
	bcfooter,
	bfooter,
	bheader,
	popup
	},
  	methods: {
  		changeRightPaneColor(color) {
  			this.rightPaneBackgrounColor['background-color'] = color
  		},
  		closeAvailableFontsDropDown(event) {
  		},
  		test(testValue){
  			this.testValue = testValue
  		},
	  	lastStep (side) {
				this.step --
				
				// this.currSideG ++
				// this.currSideG %= this.styleNumObj.sides
				this.currSideG = side
	  		console.log('currside ' + this.currSideG)
				
	  	},
	  	nextStep() {
	  		this.step ++
	  	},
	  	startOver () {
	  		// console.log(this.$refs)
	  		// this.$refs.step1.reset()
	  		this.styleNumObj = null;
	  		this.mask = null;
	  		this.theCanvas = null;
	  		this.step = 0;
	  		this.userImages = null;
	  		this.previewStyleNumObj = null;
	  		this.previewUserImgObj = null;
				this.currSideG = 0
				this.counter = 0

			this.userData= [
	        {
	          userImage: null,
	          userImageErr: null,
	          userInputType: 1,
	          userInputText1: '',
	          userInputText2: '',
	          userInputText3: '',
	          selectedFont: '',
	          isSaving: false
	        },
	         {
	          userImage: null,
	          userImageErr: null,
	          userInputType: 1,
	          userInputText1: '',
	          userInputText2: '',
	          userInputText3: '',
	          selectedFont: '',
	          isSaving: false
					}
					,
	         {
	          userImage: null,
	          userImageErr: null,
	          userInputType: 1,
	          userInputText1: '',
	          userInputText2: '',
	          userInputText3: '',
	          selectedFont: '',
	          isSaving: false
					}
					,
	         {
	          userImage: null,
	          userImageErr: null,
	          userInputType: 1,
	          userInputText1: '',
	          userInputText2: '',
	          userInputText3: '',
	          selectedFont: '',
	          isSaving: false
	        }
	      ]

	  	this.userData[0].scaleValue = 101
			this.userData[0].rotateValue = 0
			this.userData[0].grayscale = false
			this.userData[0].selected = false
			this.userData[1].scaleValue = 101
			this.userData[1].rotateValue = 0
			this.userData[1].grayscale = false
			this.userData[1].selected = false

			this.userData[2].scaleValue = 101
			this.userData[2].rotateValue = 0
			this.userData[2].grayscale = false
			this.userData[2].selected = false

			this.userData[3].scaleValue = 101
			this.userData[3].rotateValue = 0
			this.userData[3].grayscale = false
			this.userData[3].selected = false
	  	},
	  	setPreviewImageURL (previewStyleNumObj, previewUserImgObj){
	  		if(previewStyleNumObj != null) {
	  			this.previewStyleNumObj = previewStyleNumObj;
	  		if(previewUserImgObj != null)
	  			this.previewUserImgObj = previewUserImgObj;
	  		}
	  	},
	  	setUserDataFromStep2 (canvas, data) {
	  		// console.log('update from step 2')
	  		// var temp = JSON.parse(JSON.stringify(data))
	  		this.theCanvasG = canvas
	  		this.userData[0].grayscale = data[0].grayscale
	  		this.userData[0].rotateValue = data[0].rotateValue
				this.userData[0].scaleValue = data[0].scaleValue
				
	  		this.userData[1].grayscale = data[1].grayscale
	  		this.userData[1].rotateValue = data[1].rotateValue
	  		this.userData[1].scaleValue = data[1].scaleValue
				
				this.userData[2].grayscale = data[2].grayscale
	  		this.userData[2].rotateValue = data[2].rotateValue
				this.userData[2].scaleValue = data[2].scaleValue

				this.userData[3].grayscale = data[3].grayscale
	  		this.userData[3].rotateValue = data[3].rotateValue
				this.userData[3].scaleValue = data[3].scaleValue
				
	  	},
	  	setUserDataFromStep1 (data, nextStep) {
	  		// console.log('set user data ' + nextStep)
	  		if(nextStep)
		  		this.step = 2
	  		this.userData = data
	  		var previewStyleNumObj = {
	  			// url: 'https://app.brighton.com/lockets/img/'+this.styleNumObj.styleNum.toLowerCase()+'_preview1.png'
	  			url1: 'https://app.brighton.com/lockets/img/'+this.styleNumObj.styleNum.toLowerCase()+'_preview0.png?3',
				url1Top: 'https://app.brighton.com/lockets/img/'+this.styleNumObj.styleNum+'_top.png?3',
				url2: 'https://app.brighton.com/lockets/img/'+this.styleNumObj.styleNum+'_preview1.png?3'
	  		}
	  		var previewUserImgObj = {
	  			url1: 'https://app.brighton.com/lockets/img/'+this.styleNumObj.styleNum.toLowerCase()+'_preview0.png?3',
				url1Top: 'https://app.brighton.com/lockets/img/'+this.styleNumObj.styleNum+'_top.png?3',
				url2: 'https://app.brighton.com/lockets/img/'+this.styleNumObj.styleNum+'_preview1.png?3'
	  		}
	  		this.setPreviewImageURL(previewStyleNumObj, previewUserImgObj);
	  	},
	  	setPreviewUserImg (obj) {
	  		// setting user image position as user moves images in the canvas
	  		// console.log('setting preview user image')
	  		if(obj.url1 != '') 
	  			this.previewUserImgObj.url1 = obj.url1
	  		if(obj.url1Top != '') 
	  			this.previewUserImgObj.url1Top = obj.url1Top
	  		if(obj.url2 != '') 
	  			this.previewUserImgObj.url2 = obj.url2
	  		
	  		this.counter ++;
			
				this.setPreviewUserImgs()
	  		this.$forceUpdate();
				
	  	},
		setPreviewUserImgs(){
			this.theCanvasPreviewRendered = 0;
			// console.log('set preview canvas')
			if(this.userData[0].userInputType != 2) {
				this.setPreviewUserImgOne(0, 'rightSideMask', 1)
				this.setPreviewUserImgOne(0, 'rightSide', 0)
			}
			if(this.styleNumObj.sides >= 2 && this.userData[1].userInputType != 2) {
				this.setPreviewUserImgOne(1, 'leftSideMask', 1)
				this.setPreviewUserImgOne(1, 'leftSide', 0)
			}

			if(this.styleNumObj.sides >= 3 && this.userData[2].userInputType != 2) {
				this.setPreviewUserImgOne(2, 'leftSideMask2', 1)
				this.setPreviewUserImgOne(2, 'leftSide2', 0)
			}

			if(this.styleNumObj.sides >= 4 && this.userData[3].userInputType != 2) {
				this.setPreviewUserImgOne(3, 'leftSideMask3', 1)
				this.setPreviewUserImgOne(3, 'leftSide3', 0)
			}
			
		},
		setPreviewUserImgOne(side, canvasID,  applyMask){
			let userImageUrl = 'https://app.brighton.com/lockets/tmp/'+this.userData[side].userImage
			let previewImageUrl = (applyMask)?'https://app.brighton.com/lockets/img/' + this.styleNumObj.styleNum+'_mask2.png':'https://app.brighton.com/lockets/img/' + this.styleNumObj.styleNum+'_preview'+side+'.png'
			// fix for jm0068 where both sides are different shapes... eventually we'll have to do this for other styles too
			if(applyMask && this.styleNumObj.styleNum == 'jm0068' && side == 1)
				previewImageUrl = 'https://app.brighton.com/lockets/img/' + this.styleNumObj.styleNum+'_mask2_1.png'




			// let previewImageUrl = 'https://app.brighton.com/lockets/img/' + this.styleNumObj.styleNum+'_mask2.png'
			// let previewImageUrl = 'https://app.brighton.com/lockets/img/' + this.styleNumObj.styleNum+'_preview'+side+'.png'

			
			let previewImage = new Image()
			previewImage.src = previewImageUrl
			var that = this
			// let canvasID = side?'leftSide':'rightSide'

			previewImage.onload = () => {
				let maskWidth = previewImage.width, maskHeight = previewImage.height
				let previewIconHeight = 100 * maskHeight / maskWidth

				// console.log(canvasID, maskWidth, maskHeight, previewIconHeight)
				let canvas = new fabric.Canvas(canvasID)
				canvas.clear()
				canvas.setHeight(maskHeight)
				canvas.setWidth(maskWidth)
				fabric.textureSize = 4096
				fabric.Image.fromURL(previewImageUrl, (oImg) => {
					oImg.set({left: ((canvas.width / 2)), top: canvas.height /2, originX: 'center', originY: 'center'})
					canvas.add(oImg);
					if(this.userData[side].userImage != null && this.theCanvasG != null && this.theCanvasG[side] != undefined) {
						// insert user image if there's an userimage
						let obj = this.theCanvasG[side].canvas._objects[0];
						var xCoord = obj.get('left');
						var yCoord = obj.get('top');
						fabric.Image.fromURL(userImageUrl, function(oImg) {
							oImg.set({left: ((canvas.width / 2)), top: canvas.height /2, originX: 'center', originY: 'center'})
							canvas.add(oImg)
							// adjust user image to reflect user input
							canvas.item(1).set('scaleX', that.userData[side].scaleValue / 100)
							canvas.item(1).set('scaleY', that.userData[side].scaleValue / 100)
							canvas.item(1).set('angle', that.userData[side].rotateValue)
							canvas.item(1).set('top', yCoord - ((500 - maskHeight)/2) - 3)
							canvas.item(1).set('left', xCoord - ((800 - maskWidth)/2) - 3)
							canvas.forEachObject(function(object){ 
								object.selectable = false 
								object.hasControls = false
								canvas.sendToBack(object)
							});
							if(that.userData[side].grayscale) {
								var filter = new fabric.Image.filters.Grayscale();
								canvas._objects[0].filters = []
								canvas._objects[0].filters.push(filter)
							} else {
								canvas._objects[0].filters = []
							}
							canvas._objects[0].applyFilters()
							canvas.calcOffset()
							canvas.on('after:render', function(){
								console.log('after render')
								if(applyMask)
									that.theCanvasPreview[side] = canvas
								else 
								{
									document.querySelector("#"+canvasID).style.width = '100px'
									document.querySelector("#"+canvasID).style.height = previewIconHeight + 'px'
									let canvasContainers = document.querySelectorAll('.preview .canvas-container')
									_.forEach(canvasContainers, function(canvasContainer) {
											canvasContainer.style.width = '100px'
											canvasContainer.style.height = previewIconHeight + 'px'
									})
									let upperCanvases = document.querySelectorAll('.preview .upper-canvas')
									_.forEach(upperCanvases, function(upperCanvas){
											upperCanvas.style.width = '100px'
											upperCanvas.style.height = previewIconHeight + 'px'
									})
								}
							})
						})
					} else {
						canvas.forEachObject(function(object){ 
							object.selectable = false 
							object.hasControls = false
						});
						if(applyMask)
							that.theCanvasPreview[side] = canvas
					}
					// resize canvas after all rendered
					canvas.on('after:render', function(){
						if(applyMask)
							that.theCanvasPreview[side] = canvas
						else {
							document.querySelector("#"+canvasID).style.width = '100px'
							// document.querySelector("#"+canvasID).style.height = '100px'
							document.querySelector("#"+canvasID).style.height = previewIconHeight + 'px'
							let canvasContainers = document.querySelectorAll('.preview  .canvas-container')
							_.forEach(canvasContainers, function(canvasContainer) {
									canvasContainer.style.width = '100px'
									// canvasContainer.style.height = '100px'
									canvasContainer.style.height = previewIconHeight + 'px'
							})


							let upperCanvases = document.querySelectorAll('.preview .upper-canvas')
							_.forEach(upperCanvases, function(upperCanvas){
									upperCanvas.style.width = '100px'
									// upperCanvas.style.height = '100px'
									upperCanvas.style.height = previewIconHeight + 'px'
							})
						}

						that.theCanvasPreviewRendered ++;
						that.$forceUpdate();
					})
				})
			}
		},
		selectStyleNum (styleNumObj) {
			this.styleNumObj = styleNumObj;
			this.step = 1;
			// if(this.styleNumObj.sides == 2) 
			// 	this.currSideG = 1
			// else 
			// 	this.currSideG = 0
			this.setPreviewUserImgs()
			this.$forceUpdate();
		},
		save () {
			console.log(JSON.stringify(this.theCanvas));
		}
  },
  mounted () {
	  	var that = this
	  	console.log('mounted start')
		this.userData[0].scaleValue = 101
		this.userData[0].rotateValue = 0
		this.userData[0].grayscale = false
		this.userData[0].selected = false
		this.userData[1].scaleValue = 101
		this.userData[1].rotateValue = 0
		this.userData[1].grayscale = false
		this.userData[1].selected = false
		this.userData[2].scaleValue = 101
		this.userData[2].rotateValue = 0
		this.userData[2].grayscale = false
		this.userData[2].selected = false
		this.userData[3].scaleValue = 101
		this.userData[3].rotateValue = 0
		this.userData[3].grayscale = false
		this.userData[3].selected = false
		this.theCanvasPreview = [{}, {}, {}, {}]
	},
	created(){

	},
	watch:{
		orderQuantity(newValue) {
			if(isNaN(newValue)) {
				this.orderQuantity = 1;
			}
		},
  		styleNumObj(newValue, oldValue) {
  			// if(this.reloadObj != null) {
		  	// 	if(this.styleNumObj.sides == 1) {
		   //        this.setUserImages([{userImage: this.userImages[0].userImage, scaleValue : this.reloadObj[0].scaleValue1, rotateValue: this.reloadObj[0].rotateValue1, grayscale: (this.reloadObj[0].grayscale1)?true:false}]);
		   //      } else {
		   //         this.setUserImages([{userImage: this.userImages[0].userImage, scaleValue : this.reloadObj[0].scaleValue1, rotateValue: this.reloadObj[0].rotateValue1, grayscale: (this.reloadObj[0].grayscale1)?true:false}, {userImage: this.userImage[1].userImage, scaleValue: this.reloadObj[0].scaleValue2, rotateValue: this.reloadObj[0].rotateValue2, grayscale: (this.reloadObj[0].grayscale2)?true:false}]);
		   //      }
  			// }
  		}
	}
}
</script>
<style>
*{
	font-family: 'Lato',arial;
}
	#nav {
	    position: relative;
	    max-width: 1170px;
	    width: auto;
	    margin: 0 auto 0px auto;
	}
	#nav a {
	  font-weight: bold;
	  color: #2c3e50;
	}
	#nav a.router-link-exact-active {
	  color: #42b983;
	}
	#nav ul.breadcrumbs{
	  display: block;
	    list-style-type: none;
	    margin-top: 10px;
	    text-align: left;
	}
	#nav ul.breadcrumbs li {
	  display: inline-block;
	  line-height:1;
	}
	#nav ul.breadcrumbs li a {
	  font-weight:normal;
	  display: block;
	  background: url(https://www.brighton.com/store_image/site/arrow.gif) no-repeat;
	  padding-left: 9px;
	  background-position: 0 50%;
	  margin-right: 12px;
	}
	.title	{
		display:block;
		font-weight:bold;
		padding:15px 0;
	}
	button {
		background:#e03c7f;
		background:#5788a2;
		text-transform: uppercase;
		/* padding: 10px 25px; */
		padding: 10px 10px;
		border: none;
		color:#fff;
		font-weight: bold;
		cursor: pointer;
		margin-right:3px;
		margin-bottom:3px;

	}
	.home{
		position:relative;
		width:auto;
		margin-bottom:100px;
	}
	.home .main{
		display: flex;
		justify-content: center;
		webkit-box-pack: space-evenly;
    	-ms-flex-pack: space-evenly;
    	max-width:1170px;
    	margin: 0 auto;
	}
	.home .selectedStyle{
		display:block;
		margin:20px auto;
		max-width:1170px;
	}
	.home .selectedStyle .leftSide{
		display:inline-block;
		text-align: left;
		width:70%;
		vertical-align: top;

	}
	.home .selectedStyle .leftSide span{
		display:block;
	}
	.home  .selectedStyle .leftSide .t1{
		display:block;
		font-size:30px;
		font-weight:bold;
		text-transform: none;
	}
	.home .selectedStyle .leftSide .t2{
		font-size:16px;
	}
	.home .selectedStyle .leftSide .t2 a{
		text-decoration: underline;
		font-family: 'Lato';
	}
	.home .selectedStyle .leftSide .t3{
		padding: 10px 0;
		line-height: 1;
		font-family: 'lato';
		font-size: 18px;
		line-height: 1.6;
	}
	.home .selectedStyle .rightSide{
		text-align: right;
		display:inline-block;
		width:30%;	
		vertical-align: top;
	}
	.home .selectedStyle .rightSide .t1{
	    display: block;
	    text-align: right;
	    font-size: 20px;
	    line-height: 2;
		Font-weight: 700;
	}
	.home .selectedStyle .rightSide .t2{
	    display: block;
	    text-align: right;
	    margin: 10px 0;
		font-family: 'Lato';
	}
	.home .selectedStyle .rightSide .t2 input{
		display: inline-block;
		border: 1px solid #ccc;
		padding: 7px;
		width: 30px;
	}


	.home .selectedStyle .title{
		display: block;
		text-align: center;
		font-size: 50px;
		font-weight: bold;
		line-height: 1;
		color: #4d4d4d;
		padding: 50px 0 30px 0;
	}
	.home .main .left{
		display:inline-block;
		flex: 0 0 40%;
		vertical-align: top;
		width:40%;
		width:400px;
		padding:15px;
		margin-left:0;
		border: 1px solid #999;
		box-sizing: border-box;
		transition: width 0.5s, height 0.5s, opacity 0.5s, padding 0.5s;
		min-height:400px;
		text-align: center;
	}
	.home .main .left.step2{
		width:200px;
		box-sizing: border-box;
		vertical-align: top;
		overflow: hidden;

	}
	.home .main .left.step2 .preview{
		display:block;
		position:relative;
		margin: 0 auto;
		overflow:hidden;
	}
	.home .main .left.step2 .preview:after{
		content: '';
		z-index:4;
		width:100%;
		height:100%;
		position:absolute;
		top:0;
		left:0;

	}
	.home .main .left img{
	    box-sizing: border-box;
	    max-width: 100%;
	}
	.home .main .left.step2 .preview .styleNum{
		position:relative;
		z-index:2;
		width:auto;
	}
	.home .main .left .preview .userImage,
	.home .main .left.step2 .preview .userImage{
		width:auto;
		width:100px;
		display:inline-block;
		position:relative;
		overflow:hidden;
	}
	.home .main .left .preview .userImage{
		width:24%;
		width:100px;
		position:relative;
		z-index:2;
	}
	.home .main .left.step2 .preview .userImage:last-child{
		margin-left:-3px;
	}
	.home .main .left .preview .userImage .canvas-container{
		margin: 0 auto;
	}
	.home .main .left .preview .userImage:last-child{
		margin-left:-2px;
	}
	.home .main .left .preview .userImage img,
	.home .main .left.step2 .preview .userImage img{
		box-sizing: border-box;
		max-width: 100%;
		z-index: 2;
		position: relative;
		display:block;
	}
	.home .main .left .preview .userImage img.selectedImage{
		position:absolute;
		left:0;
		z-index:1;
		display:block;
		top:0;
	}

	.home .main .left .preview .userImage .chain,
	.home .main .left.step2 .preview .userImage .chain{
		width: 45%;
		margin: 0 auto;
		margin-bottom: -7px;
		z-index: 3;
		position: relative;
	}
	.home .main .left .preview .userImage .userInputText,
	.home .main .left.step2 .preview .userImage .userInputText{
		position: absolute;
		top: 28%;
		font-size: 0.7em;
		line-height: 1.5;
		width: 100%;
		text-align: center;
		z-index: 3;
	}
	.home .main .left .preview .userImage .userInputText span,
	.home .main .left.step2 .preview .userImage .userInputText span{
		display:block;
		height:14px;
	}
	.home .main .left .txt{
		margin-top:40px;
		display:block;
	}
	.home .main .middle{
		display:inline-block;
		box-sizing: border-box;
		vertical-align: top;
		width:10%;	
		padding: 0 10px;
		transition: width 0.5s, height 0.5s, opacity 0.5s, padding 0.5s;
	}
	.home .main .middle.step2{
		vertical-align: top;
	}
	.home .main .middle .step{
		display:block;
		box-sizing: border-box;
		margin:5px 0;
		border:1px solid #000;
		text-transform: uppercase;
		padding:15px 5px;
		color:#000;
		height:33%;
		background:#fff;
		transition: width 0.5s, height 0.5s, opacity 0.5s, padding 0.5s;
		vertical-align: middle;
	}
	.home .main .middle .step > span{
		vertical-align: middle;
	}
	.home .main .middle .step:after{
		content: '';
		vertical-align: middle;
		width: 0;
		display: inline-block;
		height: 100%;
	}
	.home .main .middle .step:first-child{
		margin-top:0;
	}
	.home .main .middle .step.active{
		color:#fff;
		background:#000;
		    border: 1px solid #ccc;
	}
	.home .main .middle .step span{
		display:inline-block;
	}
	.home .main .middle .step span .num{
		font-size: 40px;
		font-weight: normal;
		line-height: 1;
		display:block;
	}
	.home .main .middle.step2 .step{
		padding:82px 5px;
	}
	.home .main .right{
		padding:5px;
		background-color: #f5f5f5;
		border: 1px solid #999;
		display:inline-block;
		box-sizing: border-box;
		vertical-align: top;
		overflow:hidden;
		width:40%;
		transition: width 0.5s, height 0.5s, opacity 0.5s, padding 0.5s, background-color 0.5s ease;
		height:auto;
		padding:15px;
		text-align:center;
	}
	.home .main .right.text{
		background-color: #f1ece4;
	}
	.home .main .right.step2{
		width: 71%;
		vertical-align: middle;
	}
	.home .main .right .container{
		display:block;
	}
	.home .main .right .container .title{
		font-size:19px;
		font-weight:bold;
	    letter-spacing: 2px;
		text-transform: uppercase;
	}

	.home .main .right .container .t1{
		display: block;
		padding: 10px;
		text-align: center;
		color: #000;
		margin:0;
		font-size: 1.3em;
		line-height: 1.4;
	}
.home .main .right .container .control{
	margin-top:20px;

}




@media(max-width: 1170px) {
  #nav,
  .home .selectedStyle{
    padding:0 10px;
  }
}
@media(max-width: 800px) {
	.home .selectedStyle .leftSide{
		width:100%;
	}
	.home .selectedStyle .leftSide .t1{
		font-size:30px;
		line-height:1.3;
		font-weight:bold;
	}
	.home .selectedStyle .rightSide{
		width:100%;
	}
	.home .selectedStyle .title{
		font-size:5vw;
		padding:40px 0 10px 0;
	}
/*	.home .selectedStyle .rightSide .t2,
	.home .selectedStyle .rightSide .t1{
		text-align: left;
	}*/
}
	@media(max-width:1024px) {
	  .home .main{
	    display:block;
	  }
	  .home .main .left{
	  	min-height:auto;
	  }
	  .home .main .left.step2{
	    display:block;
	    width:100%;
	  }
	  .home .main .left.step2 img{
		/*max-width:100%;*/
	    display:inline-block;
	  }
	  .home .main .left.step2 .preview{
	  	display:inline-block;
	  	width:200px;
	  }
	  .home .main .left.step2 .preview .title{
	  	display:none;
	  }
	  .home .main .left.step2 .preview.leftSide{
	  	/*display:none;*/
	  }
	  .home .main .middle.step2{
	    display:none;
	  }
	  .home .main .right.step2{
	    display:block;
	    width:100%;
	  }
	}
	@media(max-width: 1024px) {
		.home .main{
			display:block;
			margin:0 7%;
		}
		.home .main .left{
			display:block;
			width:100%;
			margin-bottom:30px;
		}
		.home .main .left .preview.leftSide img{
			max-width:400px;
			width:100%;
		}
		.home .main .middle{
			display:none;
		}
		.home .main .right{
			width:100%;
			display:block;
		}

	}
	.landscapeModal.modal-mask{
		display:none !important;
	}
	/*.modal-mask*/	
	@media screen and (orientation:portrait) and (max-width:514px) {
		/* .landscapeModal.modal-mask{
			display:table !important;
		}
		.landscapeModal.modal-mask .modal-container{
			position:relative;
			box-sizing:border-box;
		}
		.landscapeModal .container{
			box-sizing:border-box;
			padding:20px 10px !important;
		}
		.landscapeModal .modal-header{
			font-size:30px;
			color:#000;
			text-transform: uppercase;
		}
		.landscapeModal .modal-header i.fa{
			position:absolute;
			right:0;top:0;
			font-size:25px;
		}
		.landscapeModal .modal-body{
			font-size:16px;
			margin:10px 0;
		}
		.landscapeModal .modal-body i.fa{
			font-size:80px;
			display:block;
			margin-top:20px;
		} */
	}


	/*@media(max-width:1024px){*/
	  .home .main .right{
	    padding:15px 0;
	  }
	  .playground{
	  	/*margin-top:-30px;*/
	  }
	  .control{
	  	position:relative;
	  	z-index:2;
	  	background-color: rgb(245, 245, 245);
	  	padding:10px;
	  }
	/*}*/

</style>